import { render, staticRenderFns } from "./imgsUpload.vue?vue&type=template&id=7178e1f2&scoped=true"
import script from "./imgsUpload.vue?vue&type=script&lang=js"
export * from "./imgsUpload.vue?vue&type=script&lang=js"
import style0 from "./imgsUpload.vue?vue&type=style&index=0&id=7178e1f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7178e1f2",
  null
  
)

export default component.exports